import './CountryNotAssignedModal.css';

const CountryNotAssignedModal = ({ onLogout }) => {
  return (
    <div className="country-modal-overlay">
      <div className="country-modal-content">
        <div className="country-modal-icon">
          <svg
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" stroke="#f59e0b" strokeWidth="2" />
            <path
              d="M12 8V12M12 16H12.01"
              stroke="#f59e0b"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <h2 className="country-modal-title">Country Not Assigned</h2>
        <p className="country-modal-message">
          Please contact your Administrator to assign relevant Inventory Country
        </p>
        <button className="country-modal-logout-btn" onClick={onLogout}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default CountryNotAssignedModal;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
